import MESSAGES from "@constants/messages.constants";
import { setAlertMessage } from "@reducers/alert.reducer";
import PermissionDeniedComponent from "@screens/permission-denied/permission-denied.component";
import { checkMenuAccess } from "@utils/menu-auth";
import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { menuUrl } from "../users-list/model/users-list.constants";
import { editUsersApi } from "./users-edit.component.service";
import UsersEditTemplateComponent from "./users-edit-template.component";
import { getAllRoles } from "../users-create/users-create.component.service";
import { getEditUserFormInputs } from "../model/user-edit.model";
import { PRIMARY_KEY } from "@constants/app.constants";

const {
  ALERT_TYPES: { SUCCESS, ERROR },
  USER_ALERTS: { EDIT_ALERT },
} = MESSAGES;

const UsersEditComponent = () => {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const menuAccess = checkMenuAccess(menuUrl, "write");
  const [formTriggers, setFormTriggers] = useState({
    submitTrigger: 0,
    validationTrigger: 0,
  });
  const [formInputs, setFormInputs] = useState([]);
  const handleTriggerClick = (type) => {
    if (type === "SUBMIT") {
      setFormTriggers({
        ...formTriggers,
        submitTrigger: formTriggers.submitTrigger + 1,
      });
    }
  };

  const handleBackClick = () => {
    history.push(`/${menuUrl}`);
  };

  const handleUsersSubmit = async ({ values, errors }) => {
    // INFO : check for errors and return if errors found
    if (errors.length > 0) return;

    // INFO :  construct users payload
    let usersPayload = {};
    for (let i = 0; i < values.length; i++) {
      usersPayload[values[i].name] = values[i].value;
    }

    // INFO : call edit api
    const usersResponse = await editUsersApi(
      location?.state?.row?.id,
      usersPayload
    );

    // INFO : check api response and show relevant alert message
    if (usersResponse.status) {
      dispatch(setAlertMessage({ type: SUCCESS, message: EDIT_ALERT }));
      history.push(`/${menuUrl}`);
    } else {
      dispatch(
        setAlertMessage({ type: ERROR, message: usersResponse.message })
      );
    }
  };

  const onLoad = async () => {
    const rolesListResponse = await getAllRoles();
    // console.log({ rolesListResponse });
    if (rolesListResponse.status) {
      const formatedRoleList = rolesListResponse.data.map((data) => {
        return {
          name: data.role_name,
          value: data[PRIMARY_KEY],
        };
      });

      const formInputData = getEditUserFormInputs(formatedRoleList, {
        name: location?.state?.row?.name || "",
        email: location?.state?.row?.email || "",
        username: location?.state?.row.username || "",
        password: location?.state?.row?.password || "",
        roleId: location?.state?.row?.role_id,
      });
      // console.log({ formatedRoleList, formInputData });
      setFormInputs(formInputData);
    }
  };
  useEffect(() => {
    onLoad();
  }, []);

  const templateModal = {
    formTriggers,
    formInputs,
  };

  const templateEvents = {
    handleUsersSubmit,
    handleTriggerClick,
    handleBackClick,
  };

  return menuAccess ? (
    <UsersEditTemplateComponent
      templateModal={templateModal}
      templateEvents={templateEvents}
    />
  ) : (
    <PermissionDeniedComponent />
  );
};

export default UsersEditComponent;
